import script from "./RTBPackageCampaignForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RTBPackageCampaignForm.vue?vue&type=script&setup=true&lang=js"

import "./RTBPackageCampaignForm.vue?vue&type=style&index=0&id=461549d3&lang=scss"

const __exports__ = script;

export default __exports__